const $$splitComponentImporter = () => import('/app/src/routes/profile.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
type ProfileTab = "sessions" | "reviews" | "account" | "security";
interface SessionUser {
  id: string;
  name: string;
  email: string;
  image?: string | null;
  createdAt?: string;
  role?: string;
}
export const Route = createFileRoute("/profile")({
  validateSearch: (search: Record<string, unknown>): {
    tab: ProfileTab;
  } => {
    const tab = search.tab;
    return {
      tab: tab === "account" || tab === "security" || tab === "sessions" || tab === "reviews" ? tab : "sessions"
    };
  },
  beforeLoad: async () => {
    const res = await fetch("/api/auth/get-session");
    if (!res.ok) throw redirect({
      to: "/login"
    });
    const session = await res.json();
    if (!session?.user) throw redirect({
      to: "/login"
    });
    if (session.user.role !== "user" && session.user.role !== "client") {
      throw redirect({
        to: "/dashboard"
      });
    }
    return {
      user: session.user as SessionUser
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface TabBarProps {
  tabs: {
    value: ProfileTab;
    label: string;
    icon: typeof Calendar;
  }[];
  activeTab: ProfileTab;
  onChange: (value: ProfileTab) => void;
}